import React, { useState } from 'react';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiX, FiMessageSquare, FiAlertCircle } = FiIcons;

const RejectionModal = ({ ticket, onClose, onConfirm }) => {
  const [notes, setNotes] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!notes.trim()) return alert("Please provide a reason for rejection.");
    setIsSubmitting(true);
    onConfirm(notes);
  };

  return (
    <div className="fixed inset-0 z-[110] flex items-center justify-center p-4 bg-slate-900/50 dark:bg-slate-950/90 backdrop-blur-md">
      <div className="bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-800 rounded-3xl w-full max-w-md shadow-2xl overflow-hidden">
        <div className="p-6 border-b border-slate-200 dark:border-slate-800 flex justify-between items-center bg-slate-50 dark:bg-slate-900/50">
          <div className="flex items-center gap-3">
            <div className="bg-red-50 dark:bg-red-500/20 p-2 rounded-lg">
              <SafeIcon icon={FiAlertCircle} className="text-red-500 w-5 h-5" />
            </div>
            <h2 className="text-xl font-bold text-slate-900 dark:text-white">Reject NLA Flag</h2>
          </div>
          <button onClick={onClose} className="text-slate-400 hover:text-slate-900 dark:hover:text-white transition-colors">
            <SafeIcon icon={FiX} className="w-6 h-6" />
          </button>
        </div>
        
        <form onSubmit={handleSubmit} className="p-6 space-y-4">
          <div className="bg-slate-50 dark:bg-slate-950 rounded-2xl p-4 border border-slate-200 dark:border-slate-800">
            <div className="text-[10px] font-black text-slate-500 uppercase tracking-widest mb-1">Target Part</div>
            <div className="text-slate-900 dark:text-white font-mono font-bold text-lg">{ticket.parts?.look_up_pn}</div>
            <div className="text-xs text-slate-500 dark:text-slate-400 truncate">{ticket.parts?.descrip1}</div>
          </div>

          <div className="space-y-2 text-left">
            <label className="text-xs font-bold text-slate-500 dark:text-slate-400 uppercase tracking-wider flex items-center gap-2">
              <SafeIcon icon={FiMessageSquare} className="text-blue-500" /> Administrative Reason
            </label>
            <textarea 
              required
              className="w-full bg-white dark:bg-slate-950 border border-slate-200 dark:border-slate-800 rounded-xl p-4 text-sm text-slate-900 dark:text-white focus:border-red-500 outline-none h-32 resize-none transition-all placeholder:text-slate-400 dark:placeholder:text-slate-700"
              placeholder="Explain why this part is NOT NLA (e.g. 'Found in stock at Marcone', 'Only backordered')..."
              value={notes}
              onChange={(e) => setNotes(e.target.value)}
            />
          </div>

          <div className="flex gap-3 pt-4">
            <button type="button" onClick={onClose} className="flex-1 py-3 text-slate-500 dark:text-slate-400 font-bold hover:bg-slate-100 dark:hover:bg-slate-800 rounded-xl transition-colors">
              Go Back
            </button>
            <button 
              type="submit" 
              disabled={isSubmitting}
              className="flex-2 px-8 py-3 bg-red-600 hover:bg-red-500 disabled:bg-slate-300 dark:disabled:bg-slate-800 text-white font-black rounded-xl transition-all shadow-md dark:shadow-red-900/20"
            >
              {isSubmitting ? 'PROCESSING...' : 'CONFIRM REJECTION'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default RejectionModal;